import React from 'react';
import s from './style.module.css';
import { URL } from '@Pages/url';
import { prefectureShortName } from '@Util/util';
import { prefIncludeArea } from '@Pages/setting';
import NoImage from '@Images/noimage.webp';

import LazyableImage from '@Components/lazyable_image/view';

type RecommendCourseProps = {
    courseId: number;
    courseName: string;
    courseImageUrl: string;
    prefecture: Prefecture;
};

type Prefecture = {
    id: number;
    code: number;
    name: string;
};

const RecommendCourse = (props: RecommendCourseProps) => {
    return (
        <a href={`${URL.COURSES}/${props.courseId}`} className={s.course_box}>
            <div className={s.course_image}>
                <LazyableImage src={props.courseImageUrl || NoImage} alt={props.courseName} width={208} height={104} />
                <span className={`${s.course_pref_tag} ${s[`${prefIncludeArea(props.prefecture.name)}`]}`}>
                    {prefectureShortName(props.prefecture.name)}
                </span>
            </div>
            <div className={s.course_contents}>
                <p className={s.course_name}>{props.courseName}</p>
            </div>
        </a>
    );
};

export default RecommendCourse;
